"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js");
require("core-js/modules/esnext.global-this.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createAsyncLocalStorage", {
  enumerable: true,
  get: function get() {
    return createAsyncLocalStorage;
  }
});
var FakeAsyncLocalStorage = /*#__PURE__*/function () {
  function FakeAsyncLocalStorage() {
    _classCallCheck(this, FakeAsyncLocalStorage);
  }
  _createClass(FakeAsyncLocalStorage, [{
    key: "disable",
    value: function disable() {
      throw new Error("Invariant: AsyncLocalStorage accessed in runtime where it is not available");
    }
  }, {
    key: "getStore",
    value: function getStore() {
      // This fake implementation of AsyncLocalStorage always returns `undefined`.
      return undefined;
    }
  }, {
    key: "run",
    value: function run() {
      throw new Error("Invariant: AsyncLocalStorage accessed in runtime where it is not available");
    }
  }, {
    key: "exit",
    value: function exit() {
      throw new Error("Invariant: AsyncLocalStorage accessed in runtime where it is not available");
    }
  }, {
    key: "enterWith",
    value: function enterWith() {
      throw new Error("Invariant: AsyncLocalStorage accessed in runtime where it is not available");
    }
  }]);
  return FakeAsyncLocalStorage;
}();
function createAsyncLocalStorage() {
  if (globalThis.AsyncLocalStorage) {
    return new globalThis.AsyncLocalStorage();
  }
  return new FakeAsyncLocalStorage();
}
if ((typeof exports.default === 'function' || typeof exports.default === 'object' && exports.default !== null) && typeof exports.default.__esModule === 'undefined') {
  Object.defineProperty(exports.default, '__esModule', {
    value: true
  });
  Object.assign(exports.default, exports);
  module.exports = exports.default;
}